import {
  fetchSuggestionsService
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/SearchMenu/SearchMenu.services';

export const fetchSuggestions = async({fragment = ''}) => {
  const {results} = await fetchSuggestionsService(fragment);
  return results;
};
